/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
import "./assets/styles/desktop.scss";
import "./assets/styles/tablet.scss";
import "./assets/styles/mobile.scss";
import { useEffect } from "react";
import { Navigation, Footer } from "./components";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./assets/styles/theme";
import { Routes, Route, useNavigate } from "react-router-dom";
import { mainMenuItems } from "./components/Menu";
import { FullscreenImage } from "./components/InlineImage";

function RootRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the desired URL
    navigate("/lekkveld/zomervakanties");
  }, [navigate]);

  return null; // This component doesn't render anything
}

function App() {
  useEffect(() => {
    window.scrollTo({ top: 10, left: 0, behavior: "smooth" });
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div className={`main-container`}>
        <Navigation />
        <div className="splitter" />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          {mainMenuItems.map((item, index) => (
            <Route key={"main-" + index} path={item.url} element={item.component()} />
          ))}
          {mainMenuItems.map((item, index) => (
            <Route key={"sub-" + index} path={item.url + "/*"} element={item.component()} />
          ))}
        </Routes>
        <FullscreenImage />
        <div className="splitter" />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
